import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=4d61f8f0"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d61f8f0')) {
      api.createRecord('4d61f8f0', component.options)
    } else {
      api.reload('4d61f8f0', component.options)
    }
    module.hot.accept("./ArrowLeft.vue?vue&type=template&id=4d61f8f0", function () {
      api.rerender('4d61f8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/ArrowLeft.vue"
export default component.exports